import { render, staticRenderFns } from "./addShippingAddressModal.vue?vue&type=template&id=25d1d42c&scoped=true&"
import script from "./addShippingAddressModal.vue?vue&type=script&lang=ts&"
export * from "./addShippingAddressModal.vue?vue&type=script&lang=ts&"
import style0 from "./addShippingAddressModal.vue?vue&type=style&index=0&id=25d1d42c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d1d42c",
  null
  
)

export default component.exports